module.exports = __webpack_public_path__ + "static/media/23116894_1638433842898467_7897368544849181529_o-thumb.ef00fe08.jpg";